import React from "react"

export const RealEstateIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M30 0H0V30H30V0Z" fill="#B88B2E" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 30C23.2843 30 30 23.2842 30 15C30 6.7157 23.2843 0 15 0C6.71578 0 0 6.7157 0 15C0 23.2842 6.71578 30 15 30Z"
      fill="#ff0000"
    />
    <path
      d="M10 20.75V13.8875L7.9 15.5L7 14.3L15.25 8L18.25 10.2875V8.75H20.5V12.0125L23.5 14.3L22.6 15.5L20.5 13.8875V20.75H16V16.25H14.5V20.75H10ZM11.5 19.25H13V14.75H17.5V19.25H19V12.7438L15.25 9.89375L11.5 12.7438V19.25ZM13.75 13.2688H16.75C16.75 12.8688 16.6 12.5406 16.3 12.2844C16 12.0281 15.65 11.9 15.25 11.9C14.85 11.9 14.5 12.0281 14.2 12.2844C13.9 12.5406 13.75 12.8688 13.75 13.2688Z"
      fill="white"
    />
  </svg>
)
